module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mceltis1-216e276f732fd9f03290fe1cb9735c52.jpg";